<template>
  <div>
    <admin-travel-service-item-edit />
  </div>
</template>

<script>
import AdminTravelServiceItemEdit from "../../../components/TravelService/Admin/AdminTravelServiceItemEdit";

export default {
  name: "AdminTravelServiceItemReadonlyView",
  components: {
    AdminTravelServiceItemEdit
  },
  beforeMount() {
    this.$store.commit("AdminTravelService/setIsOfferReadonly", true);
  },
  beforeDestroy() {
    this.$store.commit("AdminTravelService/setIsOfferReadonly", false);
  }
};
</script>
